import messages from '@/locale/i18n.messages';
import { createI18n } from 'vue-i18n';

export default createI18n({
    messages,
    locale: 'en',
    fallbackLocale: 'en',
    fallbackWarn: false,
    missingWarn: false,
    warnHtmlMessage: false,
    legacy: false,
    numberFormats: {
        en: {
            decimal: {
                style: 'decimal',
            },
        },
        nl: {
            decimal: {
                style: 'decimal',
            },
        },
    },
});
